export default __webpack_public_path__ + "images/logoSupermood.1ae650af8a9012c0adf92363b3ca8aa8.svg"